// @flow
import { safeCombineReducers } from 'metaup/redux/reduxUtils';
import { downloadReducer } from './DownloadPage';

export const namespace = 'download';

export const reducer = safeCombineReducers({
  download: downloadReducer,
});
